"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var compound_1 = require("./compound");
var leaf_1 = require("./leaf");
var entity_1 = require("./entity");
var QueryStringParser = require("./parser-url.js");
var FilterSyntaxParser = require("./parser-hr.js");
var FilterFactory = /** @class */function () {
  function FilterFactory() {}
  /**
   * Restore the filter object class structure from a json serialization
   * @param json: JSON in the IqlQuery Format
   */
  FilterFactory.fromJson = function (json) {
    if (json.queries) {
      return FilterFactory.compoundFromJson(json);
    } else if (json.on) {
      return FilterFactory.leafFromJson(json);
    } else if (json.uri) {
      return FilterFactory.entityFromJson(json);
    }
  };
  /**
   * Restore a Compound Filter from JSON
   * @param json JSON<IqlCompounQuery>
   */
  FilterFactory.compoundFromJson = function (json) {
    var f = new compound_1.CompoundFilter(json.operator).setIdentifier(json.identifier).setSort(json.sort).setExclude(!!json.exclude);
    json.queries.forEach(function (subJson) {
      var subF = FilterFactory.fromJson(subJson);
      f.addFilter(subF);
    });
    return f;
  };
  /**
   * Restore a Leaf Filter from JSON
   * @param json JSON<IqlLeafQuery>
   */
  FilterFactory.leafFromJson = function (json) {
    var backwardsCompatibilityRange = function (range) {
      var numToObject = function (val, include) {
        if (val === undefined) {
          return;
        } else if (Object.keys(val).length) {
          return __assign({}, val, {
            includeValue: include || val.includeValue
          });
        } else {
          return {
            value: val,
            includeValue: include
          };
        }
      };
      if (!range) {
        return undefined;
      } else {
        var lt = numToObject(range.lt, false) || numToObject(range.lte, true);
        var gt = numToObject(range.gt, false) || numToObject(range.gte, true);
        return {
          lt: lt,
          gt: gt
        };
      }
    };
    var f = new leaf_1.LeafFilter(json.on).setSearch(json.search).setRange(backwardsCompatibilityRange(json.range)).setValues(json.values).setHasValue(json.hasValue).setSort(json.sort).setExclude(!!json.exclude).setIdentifier(json.identifier);
    return f;
  };
  /**
   * Restore an Entity Filter from JSON
   * @param json JSON<IqlLeafQuery>
   */
  FilterFactory.entityFromJson = function (json) {
    var f = new entity_1.EntityFilter().setSchema(json.schema).setType(json.type).setSpace(json.space).setUri(json.uri).setExclude(!!json.exclude).setIdentifier(json.identifier).setSort(json.sort);
    return f;
  };
  FilterFactory.fromQueryString = function (queryString) {
    var filterJson = QueryStringParser.parse(queryString);
    return FilterFactory.fromJson(filterJson);
  };
  FilterFactory.fromHumanReadable = function (inputString) {
    var filterJson = FilterSyntaxParser.parse(inputString);
    return FilterFactory.fromJson(filterJson);
  };
  return FilterFactory;
}();
exports.FilterFactory = FilterFactory;